import './EditPersonalInfoPopup.scss';
import EditPersonalInfoPopupProps from './EditPersonalInfoPopupProps';
import logo_background from '../../../../assets/images/logo-background.svg';

import { IoMdClose as CloseIcon } from "react-icons/io";
import { useDispatch } from 'react-redux';
import { togglePersonalInfoPopup } from '../../../../store/actions/mainActions';
import { Fragment, useEffect, useState } from 'react';
import UsersService from '../../../../Axios/services/users.service';
import { Loader } from '../../../core/Loader/Loader';
import { useSelector } from 'react-redux';
import avatar from '../../../../assets/images/avatar.png'

import TextField from '@mui/material/TextField';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import AdapterDateFns from '@mui/lab/AdapterDateFns';
import LocalizationProvider from '@mui/lab/LocalizationProvider';
import DatePicker from '@mui/lab/DatePicker';
import { setMe } from '../../../../store/actions/authActions';

const ResetPasswordPopup = (props: EditPersonalInfoPopupProps) => {

    const { isPopup, isNew, pulledUser, history } = props;
    const { me } = useSelector((state: any) => state.auth);

    const initialState = pulledUser ? {
        fullname: "",
        email: "",
        phone: "",
        gender: 'male',
        birthDate: '',
        region: '',
        image: '',
        language: 'eng',
        password: '',
        rePassword: '',
        title: ""
    } : {
        fullname: "",
        email: "",
        phone: "",
        gender: 'male',
        birthDate: '',
        region: '',
        image: '',
        language: 'eng',
        title: ""
    }

    const initialFlow = {
        isLoading: isPopup ? false : true,
        isComplete: false
    }

    const [state, setState] = useState(initialState)
    const [flow, setFlow] = useState(initialFlow);
    const [previewImage, setPreviewImage] = useState('');

    const dispatch = useDispatch();

    const handleClose = () => {
        dispatch(togglePersonalInfoPopup(false))
    }

    const handleChange = (prop: any) => {
        setState({
            ...state,
            ...prop
        })
    }
    const isValid = (): boolean => {
        let valid: boolean = true;
        if (pulledUser && (state.password === "" || state.rePassword === '' || state.password !== state.rePassword)) {
            valid = false;
            if (
                state.fullname === "" ||
                state.email === "" ||
                state.phone === "" ||
                state.gender === "" ||
                state.birthDate === "" ||
                state.region === "" ||
                state.language === "" ||
                state.title === ""
            ) valid = false
        }
        return valid;
    }

    const submit = async () => {

        try {
            if (isValid()) {
                if (pulledUser && pulledUser._id) {

                    setFlow({
                        ...flow,
                        isLoading: true
                    })
                    await UsersService.invitation({ _id: pulledUser._id, ...state });
                    setFlow({ ...flow, isLoading: false, isComplete: true })
                } else if (me && me._id) {

                    setFlow({
                        ...flow,
                        isLoading: true
                    })
                    await UsersService.updatePassword({ _id: me._id, ...state });
                    handleClose()
                    const _me = await UsersService.me()
                    dispatch(setMe(_me));

                }
            }
        } catch (err) {
            setFlow({ ...flow, isLoading: false, isComplete: false })
            console.error(err)
        }
    }

    const goToSignIn = (e: any) => {
        e.preventDefault()
        history?.push('/');
    }

    useEffect(() => {
        if (pulledUser) {
            setState({
                fullname: (pulledUser?.firstName || pulledUser?.lastName) ? pulledUser.firstName + ' ' + pulledUser.lastName : "",
                email: pulledUser?.email ? pulledUser.email : "",
                phone: pulledUser?.phone ? pulledUser.phone : "",
                gender: pulledUser?.gender ? pulledUser.gender : "other",
                birthDate: pulledUser?.birthDate ? pulledUser.birthDate : "",
                region: pulledUser?.region ? pulledUser.region : "",
                image: '',
                language: pulledUser?.language ? pulledUser.language : "eng",
                password: '',
                rePassword: '',
                title: pulledUser?.title ? pulledUser.title : "",
            })
            setFlow({
                ...flow,
                isLoading: false
            })
        } else if (me) {
            setState({
                fullname: (me?.firstName || me?.lastName) ? me.firstName + ' ' + me.lastName : "",
                email: me?.email ? me.email : "",
                phone: me?.phone ? me.phone : "",
                gender: me?.gender ? me?.gender : "female",
                birthDate: me?.birthDate ? me?.birthDate : "",
                region: me?.region ? me?.region : "",
                image: "",
                language: me?.language ? me?.language : "en",
                title: me?.title ? me?.title : ""
            })
        }

    }, [pulledUser, me])

    useEffect(() => {
        if (state.image) {
            const reader = new FileReader();
            reader.onload = function (e: any) {
                setPreviewImage(e.target.result)
            };
            reader.readAsDataURL((state.image as any));
        }
    }, [
        state.image
    ])

    return (
        <div className="personal-info-popup">
            <div className="left h-100 d-flex flex-column py-4 px-3">
                <div className="row p-0 m-0">
                    <div className="col-12">
                        <h3>Hartman Connect</h3>
                    </div>
                    <div className="col-12">
                    
                    </div>
                </div>
                <div className={flow.isLoading || flow.isComplete ? " loading row h-100 p-0 m-0 py-3" : "row h-100 p-0 m-0 py-3"}>

                    <div className="col-12 col-md-12 d-flex flex-column justify-content-between">
                        
                        <h6>Reset password</h6> 
                        
                    </div>

                    <div className="col-12 col-md-12 d-flex flex-column justify-content-between">
                        {pulledUser ? <Fragment><div className="form-group mb-3 p-0">
                            <FormControl sx={{ minWidth: '100%' }}>
                                <TextField
                                    value={state.password}
                                    onChange={(e) => handleChange({ password: e.target.value })}
                                    id="newpassword"
                                    label="New Password"
                                    variant="outlined"
                                    type="password"
                                />
                            </FormControl>
                        </div>
                            <div className="form-group mb-3 p-0">
                                <FormControl sx={{ minWidth: '100%' }}>
                                    <TextField
                                        value={state.rePassword}
                                        onChange={(e) => handleChange({ rePassword: e.target.value })}
                                        id="repassword"
                                        label="Retype Password"
                                        variant="outlined"
                                        type="password"
                                    />
                                </FormControl>
                            </div>
                        </Fragment> : null
                        }

                        <div className="form-group mb-3 p-0">
                            <input
                                type="submit"
                                onClick={() => submit()}
                                className={!isValid() ? 'hc-input blue-1 text-center notValid' : 'hc-input blue-1 text-center'}
                                value={isNew ? 'Reset' : 'Save'}
                            // disabled={!isValid()}
                            />
                        </div>

                    </div>

                </div>

                {flow.isLoading ? <div className="loaderWrapper d-flex justify-content-center align-items-center">
                    <Loader></Loader>
                </div> : null}

                {flow.isComplete ? <div className="completeWrapper">
                    
                    <div className="d-flex justify-content-center">
                        <div className="col-4 my-4">
                            {history ? <input
                                type="submit"
                                onClick={(e) => goToSignIn(e)}
                                className={'hc-input blue-1 text-center'}
                                value={'Sign in'}
                            /> : null}
                        </div>
                    </div>

                    <h6>
                        Success! continue to Sign in..
                    </h6>

                </div> : null}
            </div>
            {isPopup && me ? <div className="right">
                <CloseIcon className="close-icon" onClick={handleClose} />
                <img className="user-photo" src={me?.image ? me?.image : avatar} alt="user" />
                <img className="logo-background" src={logo_background} alt="logo-backround" />
            </div> : null}
        </div>
    )
}

export default ResetPasswordPopup;